<template>
  <!-- 디자인 시스템: 멀티라인 텍스트 입력 (AppInput 톤). 테마는 Themeable 자동 상속, dark/light prop은 오버라이드.
       v-model 지원, auto-grow(기본): 내용에 따라 높이 확장. -->
  <div class="app-textarea" :class="{ 'app-textarea--light': lightMode }">
    <textarea
      ref="field"
      class="app-textarea__field"
      :rows="rows"
      :value="value"
      :placeholder="placeholder"
      @input="onInput"
      @keydown.esc="$emit('esc')"
    ></textarea>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";

export default {
  name: "AppTextarea",
  mixins: [Themeable], // dark/light prop + isDark(컨텍스트 상속) 제공
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    rows: { type: [Number, String], default: 2 },
    autoGrow: { type: Boolean, default: true },
  },
  computed: {
    lightMode() {
      return !this.isDark;
    },
  },
  watch: {
    // 외부에서 값이 바뀐 경우(클립 전환 등)에도 높이 재계산
    value() {
      this.$nextTick(this.fitHeight);
    },
  },
  mounted() {
    this.fitHeight();
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value);
      this.fitHeight();
    },
    fitHeight() {
      if (!this.autoGrow) return;
      const el = this.$refs.field;
      if (!el) return;
      el.style.height = "auto"; // 줄어드는 경우 대비 리셋 후 내용 높이로
      el.style.height = `${el.scrollHeight}px`;
    },
    focus() {
      if (this.$refs.field) this.$refs.field.focus();
    },
  },
};
</script>

<style scoped>
.app-textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 10px;
  border-radius: 7px;
  background: #23232f;
  border: 1px solid #2f2f3d;
  transition: border-color 0.15s ease;
}
.app-textarea:focus-within {
  border-color: rgba(145, 85, 253, 0.55);
}
.app-textarea__field {
  display: block;
  width: 100%;
  resize: none;
  background: transparent;
  border: none;
  outline: none;
  color: #e6e6ee;
  font-size: 13px;
  line-height: 1.45;
}
.app-textarea__field::placeholder {
  color: #6b6b7d;
}

/* ── light theme ── */
.app-textarea--light {
  background: #f4f3f8;
  border-color: #e2e0ec;
}
.app-textarea--light:focus-within {
  border-color: rgba(124, 77, 255, 0.5);
  background: #fff;
}
.app-textarea--light .app-textarea__field {
  color: #37324a;
}
.app-textarea--light .app-textarea__field::placeholder {
  color: #a29cb8;
}
</style>
